<template>
	<div>
		<van-sticky>
			<navbar :title="title" />
			<van-search 
        v-model="form.Search" 
        placeholder="请输入搜索关键词" 
        @search="onSearch"
        show-action
        @cancel="onSearch"
      >
        <template #action>
          <div @click="onSearch" class="search-button">搜索</div>
        </template>
      </van-search>
		</van-sticky>
		<van-tabs v-model="activeTab">
			<van-tab title="订单" >
				<div class="schedule">
					<van-list style="padding-bottom: 50px;" >
						<van-swipe-cell v-for="(item, index) in order_list" :key="index">
							<van-cell class="item-list" @click="productDetails(item.order_id)">
								<div class="user-title">
									<span class="order-title-name">
										<van-icon name="todo-list-o" />
										{{item.order_name}}
									</span>
									<span class="user-title-date" style="float: right;">{{item.create_date}}</span>
								</div>
								<div>
									<van-icon name="user-o" />
									{{item.client_name}}
								</div>
								<div style="float: left;">
									<van-icon name="cluster-o" />
									{{item.order_code}}
								</div>
								<van-tag plain type="success" class="view-button">
									左滑查看出库记录
								</van-tag>
							</van-cell>
							<div class="divider"></div>
				<template #right>
					<div class="swipe-button" >
						<van-button
							class="swipe-button"
							@click="vieworder(item.order_id)"
							square
							type="primary"
							text="出库记录"
						/>
						<van-button
							class="swipe-button"
							@click="add(item.order_id,item.client_id)"
							square
							type="warning"
							text="新增派单"
						/>
					</div>
				</template>
						</van-swipe-cell>
					</van-list>
				</div>
			</van-tab>
				<van-tab title="派单"> 
				<div class="schedule">
					<van-list style="padding-bottom: 50px;" >
						<van-swipe-cell v-for="(item, index) in dispatch_list" :key="index">
							<van-cell class="item-list" @click="viewDetails(item.dispatch_id)">
								<div class="user-title">
									<span class="order-title-name">
										<van-icon name="todo-list-o" />
										{{item.event_name}}
									</span>
									<span class="user-title-date" style="float: right;">{{item.initiate_date}}</span>
								</div>
								<div style="float: left;">
									<van-icon name="cluster-o" />
									{{item.dispatch_name}}
								</div>
							</van-cell>
							<div class="divider"></div>
						</van-swipe-cell>
					</van-list>
				</div>
				</van-tab>
			<!-- 添加更多选项卡 -->
		</van-tabs>



		<van-tabbar v-model="activeName">
			<van-tabbar-item name="dispatchsearch" icon="search " to="/dispatch/search">查询</van-tabbar-item>
			<van-tabbar-item name="organization" icon="description" to="/dispatch">我组织的</van-tabbar-item>
			<van-tabbar-item name="initiate" icon="logistics" to="/dispatch/initiate">我发起的</van-tabbar-item>
			<van-tabbar-item name="carriedOut" icon="upgrade" to="/dispatch/carriedOut">我执行的</van-tabbar-item>
			<van-tabbar-item name="add" icon="add-o" to="/dispatch/add">新增派单</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Tab,Tabs,Toast } from "vant";
import { post } from "@/api/dispatch";

export default {
	name: "customer",
	components: {
		navbar,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
	},
	data() {
		return {
			title: "项目查询",
			activeName: "dispatchsearch",
			form: {
				requestType: "query_serve",
				page: 1,
				limit: 10,
				Search: ""
			},
			activeTab: "", // 默认激活第一个选项卡
			dispatch_list: [],
			order_list: [],
			hasSearched: false,
		};
	},
	activated() {
		// console.log("页面标记"+this.$route.params.refresh);
		if (this.$route.params.refresh != true) {
			console.log("重置")
			this.activeName = "dispatchsearch";
			// 清空搜索关键词
			this.form.Search = "";
			// 清空列表数据
			this.dispatch_list = [];
			this.order_list = [];
			// 重置搜索状态
			this.hasSearched = false;
		}else{
			this.form.page = 1;
			this.$route.params.refresh = false;
		}
  },
	methods: {
		onSearch() {
			// 判断搜索关键词是否为空
			if (!this.form.Search || this.form.Search.trim() === '') {
				return Toast.fail('请输入搜索关键词');
			}
			this.form.page = 1;
			this.hasSearched = true; // 标记已执行过搜索
			this.onLoad();
		},
		onLoad() {
			post(this.form)
				.then(res => {
					// console.log(res.obj.rows.length);
					if (res.obj.rows.length > 0) {
						const parseJson = (jsonString, target) => {
							if (jsonString && jsonString.length > 0) {
								try {
									this[target] = JSON.parse(jsonString);
								} catch (error) {
									// console.error(`Failed to parse ${target}:`, error);
									// console.error(`Original JSON string for ${target}:`, jsonString);
									// 尝试清理和修复JSON
									const cleanedJson = this.cleanAndFixJson(jsonString);
										if (cleanedJson) {
											try {
											this[target] = JSON.parse(cleanedJson);
											// console.log(`Successfully parsed cleaned JSON for ${target}`);
											} catch (cleanError) {
											// console.error(`Failed to parse cleaned JSON for ${target}:`, cleanError);
											this[target] = [];
											Toast.fail(`数据解析失败1: ${target}`);
											}
										} else {
											this[target] = [];
											Toast.fail(`数据解析失败2: ${target}`);
										}
										}
								} else {
									this[target] = [];
								}
						};
						parseJson(res.obj.rows[0].dispatch_list, 'dispatch_list');
						parseJson(res.obj.rows[0].order_list, 'order_list');
					}
					// this.form.page += 1;
					// this.list.loading = false;
					// return Toast.fail("搜索成功");
				})
				.catch(err => {
					console.log(err);
					// this.list.loading = false;
					// this.list.finished = true;
					return Toast.fail("数据异常");
				});
		},// 清理和修复JSON字符串
			cleanAndFixJson(jsonString) {
			if (!jsonString || typeof jsonString !== 'string') {
				return null;
			}
			
			let cleanedJson = jsonString.trim();
			
			try {
				// 移除可能的BOM标记
				if (cleanedJson.charCodeAt(0) === 0xFEFF) {
				cleanedJson = cleanedJson.slice(1);
				}
				// 修复被截断的JSON字符串
				cleanedJson = this.fixTruncatedJson(cleanedJson);
        
				// 尝试修复常见的JSON问题
				// 1. 移除末尾的逗号
				cleanedJson = cleanedJson.replace(/,(\s*[}\]])/g, '$1');
				
				// 2. 修复未闭合的数组
				const openBrackets = (cleanedJson.match(/\[/g) || []).length;
				const closeBrackets = (cleanedJson.match(/\]/g) || []).length;
				if (openBrackets > closeBrackets) {
				cleanedJson += ']'.repeat(openBrackets - closeBrackets);
				}
				
				// 3. 修复未闭合的对象
				const openBraces = (cleanedJson.match(/\{/g) || []).length;
				const closeBraces = (cleanedJson.match(/\}/g) || []).length;
				if (openBraces > closeBraces) {
				cleanedJson += '}'.repeat(openBraces - closeBraces);
				}
				
				// 4. 确保字符串以正确的字符结束
				const lastChar = cleanedJson[cleanedJson.length - 1];
				if (lastChar !== '}' && lastChar !== ']') {
				// 尝试找到最后一个有效的结束字符位置
				const lastBrace = cleanedJson.lastIndexOf('}');
				const lastBracket = cleanedJson.lastIndexOf(']');
				const lastValidEnd = Math.max(lastBrace, lastBracket);
				
				if (lastValidEnd > 0) {
					cleanedJson = cleanedJson.substring(0, lastValidEnd + 1);
				}
				}
				
				return cleanedJson;
			} catch (e) {
				console.error('Error cleaning JSON:', e);
				return null;
			}
			},
		// 专门修复被截断的JSON
				fixTruncatedJson(jsonString) {
					if (!jsonString || jsonString.length === 0) {
						return jsonString;
					}
					
					let fixedJson = jsonString;
					
					// 检查是否以 [ 开始
					if (fixedJson.startsWith('[')) {
						// 查找最后一个完整的对象
						let lastCompleteObjectEnd = -1;
						
						// 从后往前查找可能的完整对象结尾
						for (let i = fixedJson.length - 1; i >= 0; i--) {
						if (fixedJson[i] === '}') {
							// 检查这个 } 是否是一个完整对象的结尾
							let braceCount = 0;
							let inString = false;
							let escapeNext = false;
							
							// 向前检查括号匹配
							for (let j = i; j >= 0; j--) {
							const char = fixedJson[j];
							
							if (escapeNext) {
								escapeNext = false;
								continue;
							}
							
							if (char === '\\') {
								escapeNext = true;
								continue;
							}
							
							if (char === '"' && !escapeNext) {
								inString = !inString;
								continue;
							}
							
							if (!inString) {
								if (char === '}') {
								braceCount++;
								} else if (char === '{') {
								braceCount--;
								if (braceCount === 0) {
									// 找到了一个完整的对象
									lastCompleteObjectEnd = i;
									break;
								}
								}
							}
							}
							
							if (lastCompleteObjectEnd !== -1) {
							break;
							}
						}
						}
						
						// 如果找到了最后一个完整对象的结尾
						if (lastCompleteObjectEnd !== -1 && lastCompleteObjectEnd < fixedJson.length - 1) {
						// 截取到最后一个完整对象的结尾
						fixedJson = fixedJson.substring(0, lastCompleteObjectEnd + 1);
						}
						
						// 确保数组正确结束
						if (!fixedJson.endsWith(']')) {
						// 检查是否需要添加逗号
						if (fixedJson.endsWith('}')) {
							fixedJson += ']';
						} else {
							// 如果末尾不是 }，查找合适的位置结束数组
							const lastBrace = fixedJson.lastIndexOf('}');
							if (lastBrace > 0) {
							fixedJson = fixedJson.substring(0, lastBrace + 1) + ']';
							} else {
							// 最坏情况，尝试构造一个有效的结束
							fixedJson = fixedJson.replace(/[\s\S]*?(\}[^\]}]*)$/, '$1');
							if (!fixedJson.endsWith(']')) {
								fixedJson += ']';
							}
							}
						}
						}
					}
					
					return fixedJson;
					},
		viewDetails( id) {
			this.$router.push({
				path: "/dispatch/details",
				query: { type: 0, id: id, p: false }
			});
		},
		vieworder(id) {
			this.$router.push({
				path: "/order/recordingDetails",
				query: {
					id: id,
					type: 0,
					p: 1,
				}
			});
		},
		add(id,client_id) {
			this.$router.push({
				path: "/dispatch/add",
				query: {
					orderId: id,
					clientId: client_id,
					p: 0,
				}
			});
		},
		productDetails(order_id) {
			this.$router.push({
				path: "/order/productDetails",
				query: {
					id: order_id,
					p: 1,
				},
			});
		},
	}
};
</script>

<style lang="scss" scoped>
.swipe-button {
	height: 100%;
}
// 添加搜索按钮样式
.search-button {
  background-color: #1989fa; // vant 主题色
  color: white;
  padding: 0 10px;
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  font-size: 14px;
  
  &:active {
    background-color: #0570db;
  }
}
.schedule {
	margin-top: 30px;
	// overflow: hidden;

	.van-panel__content {
		padding: 10px 20px;
	}

	&+.schedule {
		margin-top: 15px;
	}

	&-body {
		font-size: 0.8em;
		position: relative;

		p {
			margin: 0.5em 0;
		}

		.tag-status {
			position: absolute;
			right: 0;
			top: 0;
		}
	}
}
.view-button {
  float: right;
  margin-top: 5px;
}
.divider {
  height: 1px;
//   background-color: black; /* 黑色分隔线 */
  margin-top: 10px; /* 分隔线上下间距 */
}
.swipe-button {
	height: 100%;
}
.order-title-name {
//   font-weight: 100;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: calc(80% - 100px); // 根据实际需要调整宽度
}

</style>

